export const usePipelineEditorV2Enabled = () => true;
